module.exports = __webpack_public_path__ + "static/media/recentTimer.e46ecf96.svg";